"use client"

import { useRouter } from "next/navigation"
import colors from "theme/colors"
import { TypographyRtl } from "theme/shared"
import BackIcon from "./icons/BackIcon"

const BackButton = () => {
  const router = useRouter()

  const handleBack = () => {
    router.back()
  }

  return (
    <div
      onClick={handleBack}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        cursor: "pointer",
      }}
    >
      <BackIcon width="14px" height="14px" color={colors.onyx} />
      <TypographyRtl
        $fontSize="16px"
        $fontWeight="300"
        $color="rgb(86, 96, 102)"
      >
        חזרה
      </TypographyRtl>
    </div>
  )
}

export default BackButton
